import React, { createContext, useContext, useEffect } from 'react';
import { useWebSocket } from '../hooks/useWebSocket';

/**
 * WalletContext - только для WebSocket соединения
 * Данные кошелька (balance) хранятся в Redux store и доступны через useWalletRedux()
 */
const WalletContext = createContext(undefined);

export const WalletProvider = ({ children, userId }) => {
  const { isConnected, lastUpdate, ping, reconnect } = useWebSocket(userId);

  // Периодическая проверка соединения
  useEffect(() => {
    if (!isConnected && ping) {
      const interval = setInterval(() => {
        ping();
      }, 30000); // каждые 30 секунд

      return () => clearInterval(interval);
    }
  }, [isConnected, ping]);

  return (
    <WalletContext.Provider value={{ 
      isConnected, 
      lastUpdate,
      ping,
      reconnect,
    }}>
      {children}
    </WalletContext.Provider>
  );
};

/**
 * Хук для работы с WebSocket соединением
 * Для данных кошелька используйте useWalletRedux() из hooks/useWalletRedux.js
 */
export const useWalletConnection = () => {
  const context = useContext(WalletContext);
  if (!context) {
    throw new Error('useWalletConnection must be used within WalletProvider');
  }
  return context;
};

/**
 * @deprecated Используйте useWalletRedux() для данных кошелька и useWalletConnection() для WebSocket
 * Оставлено для обратной совместимости
 */
export const useWallet = () => {
  const context = useContext(WalletContext);
  if (!context) {
    throw new Error('useWallet must be used within WalletProvider');
  }
  return context;
};
